export default "/images/vendor/flag-icons/flags/1x1/gs.svg?9d17b64612b5ef9cfe1340cebc4e49bc";